const FormInputChange = (e, formData, setFormData, redux, errors, setErrors) => {
  const { name, value, type, checked, files } = e.target;
  let newValue;
  // Handle different input types
  if (type === "checkbox") {
    // For checkboxes, use the checked value
    newValue = checked;
  } else if (type === "file") {
    // For file inputs, handle file uploads
    newValue = files.length > 1 ? [...files] : files[0];  // Support for multiple files or a single file
  } else {
    // For other input types (text, number, etc.)
    newValue = value;
  }
  
  // Update formData based on whether redux is used
  if (redux) {
    setFormData(name, newValue);
  } else {
    setFormData({
      ...formData,
      [name]: newValue,
    });
  }
  // Clear any errors associated with the field
  setErrors({
    ...errors,
    [name]: "",
  });
};

export default FormInputChange;
